module.exports = __webpack_public_path__ + "static/media/logo_escribli_blue.e69d265f.png";